module.exports = __webpack_public_path__ + "static/img/appPage_8.4e573c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appPage_8.png
// module id = 5+MR
// module chunks = 1